module.exports = __webpack_public_path__ + "static/media/telemed-icon-active.c1aed992.svg";